import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Image, ImageProps } from '../utils/local-antd';
import { AtiraIcon } from './AtiraIcon';
import { Flex } from './Flex';
import { Text } from './Text';

const StyledImage = styled(Image)`
  .ant-image-img .ant-image {
    width: auto !important;
  }
`;

export interface AtiraImageProps extends ImageProps {
  width?: string | number;
  height?: string;
  src: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const AtiraImage: React.FC<AtiraImageProps> = ({
  width,
  height,
  src,
  onClick,
  style,
  preview = false,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <StyledImage
      referrerPolicy="no-referrer"
      alt="atira_image"
      src={src}
      width={width}
      height={height}
      onClick={onClick}
      style={style}
      preview={
        preview
          ? {
              mask: (
                <Flex alignItems="center" gap="s">
                  <AtiraIcon icon={faEye} />
                  <Text color="fgSecondary">{t('common.preview')}</Text>
                </Flex>
              ),
              toolbarRender: () => null,
            }
          : false
      }
      {...props}
    />
  );
};
